import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';

const NotFound = (props) => (
	<Paper className={props.classes.paper}>
		<Typography type="display2" align="center" color="primary">404 - Error</Typography>
		<Typography type="subheading" align="center" color="textSecondary">The page you are looking for does not exist.</Typography>
	</Paper>
);

NotFound.propTypes = {
	classes: PropTypes.object.isRequired
};

const styles = theme => ({
	paper: {
		padding: theme.spacing.unit * 4,
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing.unit * 8,
		}
	}
});

export default withStyles(styles)(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js